import { SettingRow } from '@vnetwork/ui/layout';
import {
  Switch,
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardBody,
} from '@vnetwork/ui/primitives';
import { useTheme } from '@vnetwork/ui/provider';
import { Moon } from 'lucide-react';

/** App preferences. Currently the light/dark theme toggle (persisted by the DS provider). */
export function AppSettingsCard() {
  const [theme, setTheme] = useTheme();
  const isDark = theme === 'dark';

  return (
    <Card>
      <CardHeader>
        <CardTitle>App settings</CardTitle>
        <CardDescription>Personalize how the console looks.</CardDescription>
      </CardHeader>
      <CardBody>
        <SettingRow
          title={
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--vn-space-2)' }}>
              <Moon size={16} />
              Dark mode
            </span>
          }
          description="Use a darker color theme across the console."
          control={
            <Switch
              checked={isDark}
              onCheckedChange={(next) => setTheme(next ? 'dark' : 'light')}
              aria-label="Toggle dark mode"
            />
          }
        />
      </CardBody>
    </Card>
  );
}
